<template>
<div class="card">
  <!-- 手機版卡片詳情頁面 -->
  <div class="card-title">Cards
    <img
      v-if="activeTab === 'transactions'"
      src="@/assets/images/icon/search.png"
      alt="search"
      class="search-icon"
      role="button"
      tabindex="0"
      @click="toggleFilters"
      @keydown.enter.prevent="toggleFilters"
      @keydown.space.prevent="toggleFilters"
    >
  </div>
  
  <div class="mobile-card-detail">
    <!-- Tabs -->
    <div class="card-tabs">
      <div :class="['tab', {active: activeTab === 'details'}]" @click="activeTab = 'details'">Card details</div>
      <div :class="['tab', {active: activeTab === 'transactions'}]" @click="activeTab = 'transactions'">Transactions</div>
    </div>

    <!-- Card Details -->
    <div v-if="activeTab === 'details'" class="tab-content">
      <div class="card-body">
        <div>
          <img src="@/assets/images/driver/small-card.png" class="small-card-img" alt="card-detail" />
        </div>
        <div class="card-number">{{ cardStore.cardInfo?.external_account_id }}</div>
        <div class="left-text">Balance</div>
        <div class="card-balance-amount">${{ cardStore.cardInfo?.balance }}</div>
        <div class="left-text">Verification status</div>
        <div v-if="cardStore.cardInfo?.status === 'closed'" class="card-verification-status status-blocked"> 
          <img src="@/assets/svg/alert.svg" alt="close-card">Card Closed
        </div>
        <div v-else-if="cardStore.cardInfo?.is_compliant==true" class="card-verification-status status-verified">Verified</div>
        <div v-else-if="cardStore.cardInfo?.is_compliant==false && cardStore.cardInfo?.balance<1000" class="card-verification-status status-blocked">
          Unverified
          <div class="mt-3 unverified-text">
            Once your card balance exceeds $1,000, it will be temporarily blocked until ID verification is completed.
          </div>
          <div class="mt-3 unverified-text">
            Verification usually completes automatically within minutes. If manual verification is needed, you'll receive an SMS with a secure link to finish the process.
          </div>
          <!-- <div class="mt-3 d-flex">
            <button class="btn btn-verify">Verify card now</button>
            <div class="external-link">(External link)</div>
          </div> -->
        </div>
        <div v-else-if="cardStore.cardInfo?.is_compliant==false && cardStore.cardInfo?.balance>=1000" class="card-verification-status status-blocked">
          <img src="@/assets/svg/alert.svg">  
          Card blocked 
          <div class="card-verification-status status-blocked">
            Verification required
          </div> 
          <div class="mt-3 unverified-text">
            Once your card balance exceeds $1,000, it will be temporarily blocked until ID verification is completed.
          </div>
          <div class="mt-3 unverified-text">
            Verification usually completes automatically within minutes. If manual verification is needed, you'll receive an SMS with a secure link to finish the process.
          </div>
          <!-- <div class="mt-3 d-flex">
            <button class="btn btn-verify">Verify card now</button>
            <div class="external-link">(External link)</div>
          </div> -->
        </div>
        <hr>
        <div class="mt-5">
          <div class="switch-row">
            <div class="custom-switch-group">
              <label class="custom-switch">
                <input type="checkbox" :checked="lockCard" @change="onSwitch('lock', $event)" :disabled="showPopover || isLockCardDisabled">
                <span class="custom-slider" :class="{ checked: lockCard }"></span>
              </label>
              <span class="switch-label">Temporarily lock card</span>
              <!-- 鎖定卡片時的提示窗（開關關閉，要開啟） -->
              <div v-if="showPopover && popoverType === 'lock'" class="switch-popover-mask" @click.self="cancelSwitch">
                <div class="switch-popover" ref="popoverRef" tabindex="0">
                  <div class="popover-content">
                    <div class="popover-title">Are you sure you want to temporarily lock this card?</div>
                    <div class="popover-desc">This will temporarily disable all transactions, you can unlock it anytime.</div>
                    <div class="popover-actions">
                      <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                      <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 解鎖卡片時的提示窗（開關開啟，要關閉） -->
              <div v-if="showPopover && popoverType === 'unlock'" class="switch-popover-mask" @click.self="cancelSwitch">
                <div class="switch-popover" ref="popoverRef" tabindex="0">
                  <div class="popover-content">
                    <div class="popover-title">Are you sure you want unlock this card?</div>
                    <div class="popover-desc">Your card will be active again and ready to use for all transactions.</div>
                    <div class="popover-actions">
                      <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                      <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-switch-group">
              <label class="custom-switch">
                <input type="checkbox" :checked="deactivateCard" @change="onSwitch('deactivate', $event)" :disabled="showPopover || isLostStolenDisabled">
                <span class="custom-slider" :class="{ checked: deactivateCard }"></span>
              </label>
              <span class="switch-label">Lost / stolen</span>
              <!-- 標記為 lost/stolen 時的提示窗（開關關閉，要開啟） -->
              <div v-if="showPopover && popoverType === 'deactivate'" class="switch-popover-mask" @click.self="cancelSwitch">
                <div class="switch-popover" ref="popoverRef" tabindex="0">
                  <div class="popover-content">
                    <div class="popover-title">Are you sure you want to mark the card as lost or stolen?</div>
                    <div class="popover-desc">
                      <p>This will temporarily disable all transactions to keep your card secure.</p>
                      <p>If you find your card, you can unlock it here as well.</p>
                      <p>If the card cannot be recovered, contact customer service to arrange a replacement – a $15 reissue fee will apply.</p>
                    </div>
                    <div class="popover-actions">
                      <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                      <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 移除 lost/stolen 狀態時的提示窗（開關已開啟，要關閉） -->
              <div v-if="showPopover && popoverType === 'remove-lost-stolen'" class="switch-popover-mask" @click.self="cancelSwitch">
                <div class="switch-popover" ref="popoverRef" tabindex="0">
                  <div class="popover-content">
                    <div class="popover-title">Are you sure you want to remove the lost / stolen status?</div>
                    <div class="popover-desc">Your card will be active again and ready to use for all transactions.</div>
                    <div class="popover-actions">
                      <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                      <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="mt-3 d-flex">
              <button class="btn btn-verify w-100" :disabled="isCardClosed" @click="changPin">Change PIN</button>
              <div class="external-link w-100">(External link)</div>
        </div>
        <hr>
        <!-- Deactivate / Cancel Card Button -->
        <div class="deactivate-cancel-container">
          <button 
            class="btn-deactivate-cancel" 
            @click="showDeactivatePopover"
            :disabled="isCardClosed"
            :class="{ 'disabled': isCardClosed }"
          >
            Deactivate / cancel card
          </button>
          <div v-if="showPopover && popoverType === 'deactivate-cancel'" class="switch-popover-mask" @click.self="cancelSwitch">
            <div class="switch-popover" ref="popoverRef" tabindex="0">
              <div class="popover-content">
                <div class="popover-title">Are you sure you want to deactivate this card?</div>
                <div class="popover-desc">Once deactivated, this card will be permanently blocked.Any remaining balance will be forfeited</div>
                <div class="popover-desc">If you would like to be issued with a new card, please submit a new application– note that a $15 card reissuing fee applies.</div>
                <div class="popover-actions">
                  <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                  <button class="btn-link text-primary" @click="confirmDeactivateCancel">YES</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Transactions -->
    <div v-else class="tab-content">
      <div class="transaction-history">
        <!-- <h4 class="transaction-title">Transaction history</h4> -->
        <p class="transaction-note">You can view transaction history from the past 180 days.</p>
        
        <Transition name="fade-slide">
        <div class="search-section" v-show="showFilters">
          <div class="date-filters">
            <div class="filter-group">
              <label for="from-date">From</label>
              <div class="input-group">
                <Datepicker1 
                  class="datepicker-here form-control digits" 
                  v-model="dateFrom" 
                  :format="'dd/MM/yyyy'" 
                  :time-picker="false" 
                  teleport="body"
                  :auto-position="false"
                  position="center"
                  :offset="6"
                  menu-class-name="mobile-datepicker-menu"
                  :max-date="maxDate"
                  :min-date="minDate"
                  data-language="en" 
                  placeholder="Select date" 
                />
              </div>
            </div>
            <div class="filter-group">
              <label for="to-date">To</label>
              <div class="input-group">
                <Datepicker1 
                  class="datepicker-here form-control digits" 
                  v-model="dateTo" 
                  :format="'dd/MM/yyyy'" 
                  :time-picker="false" 
                  teleport="body"
                  :auto-position="false"
                  position="center"
                  :offset="6"
                  menu-class-name="mobile-datepicker-menu"
                  :max-date="maxDate"
                  :min-date="minDate"
                  data-language="en" 
                  placeholder="Select date" 
                />
              </div>
            </div>
          </div>
          <button class="search-btn" @click="searchTransactions(1)">Search</button>
        </div>
        </Transition>
        
        <div class="transactions-list">
        <div v-if="transactions.length === 0" class="no-transactions">
          <p>No transactions found for the selected date range.</p>
        </div>
          <div v-else class="transaction-header">
            <div class="header-left"></div>
            <div class="header-right">
              <div class="header-amount">Amount</div>
              <!-- <div class="header-balance">Balance</div> -->
            </div>
          </div>
                <div v-for="transaction in transactions" :key="transaction.id" class="transaction-item">
                  <div class="transaction-row" @click="openTransactionDetail(transaction)">
                    <div class="transaction-left">
                      <div class="transaction-date">{{ transaction.date }}</div>
                      <div class="transaction-desc">{{ transaction.card_acceptor_location }}</div>
                    </div>
                    <div class="transaction-right">
                      <div class="transaction-amount" :class="transaction.amount >= 0 ? 'money-in' : 'money-out'">
                        {{ transaction.amount >= 0 ? `+$${transaction.amount}` : `-$${Math.abs(transaction.amount)}` }}
                      </div>
                      <!-- <div class="transaction-balance">{{ `$${transaction.balance}` }}</div> -->
                    </div>
                  </div>
                </div>
      </div>
    </div>
  </div>
  </div>
  <!-- 分頁控制項 - 移到最底部 -->
  <div v-if="activeTab === 'transactions'" class="pagination-container">
    <div class="pagination-controls">
      <div class="pagination-left">
        <button @click="goToPage(1)" :disabled="currentPage === 1" class="pagination-btn" title="第一頁">
          <img src="@/assets/images/icon/End arrow Mobile.png" alt="End arrow Mobile" class="arrow-icon rotate-180">
        </button>
        <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1" class="pagination-btn" title="上一頁">
         <img src="@/assets/images/icon/next.png" alt="next" class="arrow-icon rotate-180 " style="width:16px;height:16px;">
        </button>
      </div>

      <div class="pagination-center">
        <span class="page-label">Page</span>
        <input 
          v-model.number="pageInput" 
          @keyup.enter="goToPage(pageInput)"
          @blur="goToPage(pageInput)"
          type="number" 
          :min="1" 
          :max="paginationMeta.total_pages"
          class="page-input"
        />
        <span class="page-total">of {{ paginationMeta.total_pages }}</span>
      </div>

      <div class="pagination-right">
        <button @click="goToPage(currentPage + 1)" :disabled="currentPage === paginationMeta.total_pages" class="pagination-btn" title="下一頁">
          <img src="@/assets/images/icon/next.png" alt="next" class="arrow-icon " style="width:16px;height:16px;">
        </button>
        <button @click="goToPage(paginationMeta.total_pages)" :disabled="currentPage === paginationMeta.total_pages" class="pagination-btn" title="最後一頁">
          <img src="@/assets/images/icon/End arrow Mobile.png" alt="End arrow Mobile" class="arrow-icon">
        </button>
      </div>
    </div>
    
    
    
  </div>
  <div v-if="showKycModal" class="kyc-modal-mask" @click.self="closeKycModal">
    <div class="kyc-modal">
      <div class="kyc-modal-title">
        <img src="@/assets/svg/alert.svg" alt="alert" class="kyc-alert-icon">
        Verification Required
      </div>
      <div class="kyc-modal-text">
        We couldn't complete your identity verification automatically.
      </div>
      <div class="kyc-modal-text">
        Please complete manual KYC verification using the link below:
      </div>
      <a
        v-if="kycVerificationLink"
        class="kyc-modal-link"
        :href="kycVerificationLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ kycVerificationLink }}
      </a>
      <div v-else class="kyc-modal-link-disabled">
        Verification link is not available yet. Please contact support.
      </div>
      <div class="kyc-modal-warning">
        Your card will remain temporarily blocked until verification is completed.
      </div>
    </div>
  </div>

  <!-- 交易明細右側抽屜面板 -->
  <TransactionDetailDrawer
    v-model="showTransactionModal"
    :detail="transactionDetail"
    :has-prev="hasPrevTransaction"
    :has-next="hasNextTransaction"
    @prev="goToPrevTransaction"
    @next="goToNextTransaction"
  />
</div>
</template>

<script setup>
import { ref, computed, nextTick, onMounted, onBeforeUnmount, defineProps, watch } from 'vue'
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { useCardStore } from '@/store/driver/card';
import TransactionDetailDrawer from '@/components/driver/TransactionDetailDrawer.vue';
import { mapCardTransactionListItem, toTransactionDetail } from '@/utils/cardTransactionDetail';

const activeTab = ref('details')
const showFilters = ref(false)

function toggleFilters() {
  // 僅在交易分頁可切換
  if (activeTab.value !== 'transactions') return
  showFilters.value = !showFilters.value
}

const props = defineProps({
  verificationStatus: {
    type: String,
    default: 'blocked'
  }
})

// 初始化 card store
const cardStore = useCardStore()

// 計算屬性：根據卡片狀態控制開關
const cardStatus = computed(() => cardStore.cardInfo?.status)

// 計算屬性：判斷是否因為未驗證且餘額過高而需要禁用
const isDisabledDueToUnverified = computed(() => {
  const balance = parseFloat(cardStore.cardInfo?.balance) || 0
  const isCompliant = cardStore.cardInfo?.is_compliant
  return balance >= 1000 && isCompliant === false
})

// 計算屬性：判斷卡片是否已關閉
const isCardClosed = computed(() => {
  return cardStatus.value === 'closed'
})

// 計算屬性：判斷 temporarily lock card 開關是否應該禁用
const isLockCardDisabled = computed(() => {
  return cardStatus.value === 'lost_or_stolen' || deactivateCard.value === true || isDisabledDueToUnverified.value || isCardClosed.value
})

// 計算屬性：判斷 lost/stolen 開關是否應該禁用
const isLostStolenDisabled = computed(() => {
  return cardStatus.value === 'inactive' || isDisabledDueToUnverified.value || isCardClosed.value
})

// 計算屬性：根據卡片狀態設置 temporarily lock card 的初始狀態
const shouldLockCardBeOn = computed(() => {
  return cardStatus.value === 'inactive'
})

const lockCard = ref(false)
const deactivateCard = ref(false)
const showPopover = ref(false)
const popoverType = ref('lock')
const popoverRef = ref(null)
const showKycModal = ref(false)
const hasShownKycModal = ref(false)
const pageSize = 10
const currentPage = ref(1)
const pageInput = ref(1)

function extractKycLink(payload) {
  if (!payload) return ''
  if (typeof payload === 'string') return payload
  if (typeof payload !== 'object') return ''

  const directLink = payload.link || payload.url || payload.kyc_url || payload.verification_url || payload.manual_kyc_url
  if (directLink && typeof directLink === 'string') return directLink

  for (const value of Object.values(payload)) {
    const nestedLink = extractKycLink(value)
    if (nestedLink) return nestedLink
  }

  return ''
}

const kycVerificationLink = computed(() => {
  return extractKycLink(cardStore.kycStatus)
})

// Transaction history data - 預設為當月1號到31號
const today = new Date()
const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
const dateFrom = ref(firstDayOfMonth)
const dateTo = ref(lastDayOfMonth)
const transactions = ref([])

// 交易明細抽屜面板
const showTransactionModal = ref(false)
const selectedTransactionIndex = ref(-1)
const transactionDetail = ref({
  merchant: '',
  amount: '',
  date: '',
  time: '',
  cardType: '',
  paymentStatus: '',
  reference: ''
})

const hasPrevTransaction = computed(() => selectedTransactionIndex.value > 0)
const hasNextTransaction = computed(() => (
  selectedTransactionIndex.value >= 0 &&
  selectedTransactionIndex.value < transactions.value.length - 1
))

function setTransactionDetail(index) {
  const transaction = transactions.value[index]
  if (!transaction) return

  selectedTransactionIndex.value = index
  transactionDetail.value = toTransactionDetail(transaction, {
    showCardType: false
  })
}

function openTransactionDetail(transaction) {
  const index = transactions.value.findIndex((item) => item.id === transaction.id)
  if (index === -1) return

  setTransactionDetail(index)
  showTransactionModal.value = true
}

function goToPrevTransaction() {
  if (!hasPrevTransaction.value) return
  setTransactionDetail(selectedTransactionIndex.value - 1)
}

function goToNextTransaction() {
  if (!hasNextTransaction.value) return
  setTransactionDetail(selectedTransactionIndex.value + 1)
}

// 分頁相關變數
const paginationMeta = ref({
  total_pages: 1,
  total_items: 0
})
// 分頁計算屬性
const totalPages = computed(() => {
  return parseInt(paginationMeta.value?.total_pages) || 1
})

// 分頁計算屬性
const pagination = computed(() => {
  // 使用後端分頁大小（20筆）
  const pageSize = 20
  const totalPages = parseInt(paginationMeta.value?.total_pages) || 1
  const totalItems = parseInt(paginationMeta.value?.total_items) || 0
  const current = parseInt(currentPage.value) || 1
  
  // 確保 current 是有效的數字
  const validCurrent = Math.max(1, Math.min(current, totalPages))
  
  const startItem = Math.max(1, (validCurrent - 1) * pageSize + 1)
  const endItem = Math.min(validCurrent * pageSize, totalItems)
  
  return {
    currentPage: validCurrent,
    totalPages: Math.max(1, totalPages),
    totalItems: Math.max(0, totalItems),
    pageSize,
    startItem: Math.max(1, startItem),
    endItem: Math.max(0, endItem)
  }
})

const shouldPromptKyc = computed(() => {
  return isDisabledDueToUnverified.value
})

function closeKycModal() {
  showKycModal.value = false
}

function changPin() {
  window.open('https://pin.emerchants.com.au/', '_blank')
}
// 日期選擇器限制：今天往前算180天
const maxDate = computed(() => {
  return new Date() // 今天
})

const minDate = computed(() => {
  const minDate = new Date()
  minDate.setDate(minDate.getDate() - 180) // 往前算180天
  return minDate
})

function goToPage(page) {
  if (page < 1) page = 1
  if (page > paginationMeta.value.total_pages) page = paginationMeta.value.total_pages
  currentPage.value = page
  pageInput.value = page
  searchTransactions(page)
}

// 格式化日期為 API 需要的格式
function formatDateForAPI(date) {
  if (!date) return ''
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 格式化日期為顯示格式
function formatDateForDisplay(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear()).slice(-2)
  return `${day}/${month}/${year}`
}

async function searchTransactions(page = 1) {
  try {
    // 準備查詢參數 - 使用後端分頁
    const searchParams = {
      from: formatDateForAPI(dateFrom.value),
      to: formatDateForAPI(dateTo.value),
      page: page
    }
    
    console.log('📋 查詢參數:', searchParams)
    
    // 調用 cardStore 的 API
    console.log('🌐 調用 getCradTransaction API...')
    const response = await cardStore.getCradTransaction(searchParams)
    
    console.log('📦 API 回傳的完整響應:', response)
    
    // 使用後端分頁資訊
    if (response?.transactions && Array.isArray(response.transactions)) {
      // 更新分頁資訊（使用後端返回的 meta）
      const newTotalPages = parseInt(response.meta?.total_pages) || 1
      const newTotalItems = parseInt(response.meta?.total_items) || 0
      
      // 如果返回的頁數或項目數為0，但我們有交易數據，保持之前的值
      if (newTotalPages === 1 && newTotalItems === 0 && response.transactions.length > 0) {
        console.log('⚠️ 後端返回異常的 meta 信息，保持之前的分頁資訊')
        // 不更新 paginationMeta，保持之前的值
      } else {
        paginationMeta.value = {
          total_pages: newTotalPages,
          total_items: newTotalItems
        }
      }
      
      currentPage.value = page
      pageInput.value = page
      
      console.log('🔍 分頁資訊更新:', {
        total_pages: paginationMeta.value.total_pages,
        total_items: paginationMeta.value.total_items,
        currentPage: currentPage.value,
        responseMeta: response.meta
      })
      
      transactions.value = response.transactions.map(mapCardTransactionListItem)
      
      console.log('✅ 交易記錄載入成功:', transactions.value.length, '筆')
    }
  } catch (error) {
    console.error('❌ 載入交易記錄失敗:', error)
    transactions.value = []
    paginationMeta.value = {
      total_pages: 1,
      total_items: 0
    }
  }
}

async function onSwitch(type, event) {
  if (type === 'lock') {
    if (lockCard.value) {
      // 開→關，解鎖卡片，顯示提示窗
      event.preventDefault()
      popoverType.value = 'unlock'
      showPopover.value = true
      nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
    } else {
      // 關→開，彈窗確認鎖定
      event.preventDefault()
      popoverType.value = type
      showPopover.value = true
      nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
    }
  } else if (type === 'deactivate') {
    event.preventDefault()
    if (deactivateCard.value) {
      // 開→關，移除 lost/stolen 狀態，顯示移除提示窗
      popoverType.value = 'remove-lost-stolen'
      showPopover.value = true
      nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
    } else {
      // 關→開，標記為 lost/stolen，顯示標記提示窗
      popoverType.value = type
      showPopover.value = true
      nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
    }
  }
}
async function confirmSwitch() {
  showPopover.value = false
  try {
    if (popoverType.value === 'lock') {
      lockCard.value = true
      await cardStore.lockCard('lock')  // 鎖定卡片
      // 重新載入卡片資訊以更新狀態
      await cardStore.fetchCardInfo()
    } else if (popoverType.value === 'unlock') {
      // 解鎖卡片
      lockCard.value = false
      await cardStore.activateCard(cardStore.cardInfo?.external_account_id)  // 解鎖卡片
      // 重新載入卡片資訊以更新狀態
      await cardStore.fetchCardInfo()
    } else if (popoverType.value === 'deactivate') {
      // 標記為 lost/stolen（開關關閉，要開啟）
      deactivateCard.value = true
      await cardStore.lostCard()  // 標記為遺失卡片
      // 重新載入卡片資訊以更新狀態
      await cardStore.fetchCardInfo()
    } else if (popoverType.value === 'remove-lost-stolen') {
      // 移除 lost/stolen 狀態（開關已開啟，要關閉）
      deactivateCard.value = false
      await cardStore.activateCard(cardStore.cardInfo?.external_account_id)  // 重新激活卡片
      // 重新載入卡片資訊以更新狀態
      await cardStore.fetchCardInfo()
    }
  } catch (error) {
    console.error('Error performing card action:', error)
    // 如果操作失敗，恢復開關狀態
    if (popoverType.value === 'lock') {
      lockCard.value = false
    } else if (popoverType.value === 'unlock') {
      lockCard.value = true
    } else if (popoverType.value === 'deactivate') {
      deactivateCard.value = false
    } else if (popoverType.value === 'remove-lost-stolen') {
      deactivateCard.value = true
    }
  }
}
function cancelSwitch() {
  showPopover.value = false
}

// 激活卡片的方法
async function activateCard(EAID) {
  try {
    await cardStore.activateCard(EAID)
    // 重新載入卡片資訊以更新狀態
    await cardStore.fetchCardInfo()
    console.log('Card activated successfully')
  } catch (error) {
    console.error('Error activating card:', error)
  }
}

function showDeactivatePopover() {
  popoverType.value = 'deactivate-cancel'
  showPopover.value = true
  nextTick(() => { if (popoverRef.value) popoverRef.value.focus() })
}

async function confirmDeactivateCancel() {
  showPopover.value = false
  try {
    const result = await Swal.fire({
      title: 'This action is permanent. Once deactivated, this card cannot be used again.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Permanently deactivate',
      cancelButtonText: 'Cancel'
    })
    
    if (result.isConfirmed) {
      try {
        await cardStore.lockCard('closed')
        // 重新載入卡片資訊
        await cardStore.fetchCardInfo()
        
        // 顯示成功訊息
        Swal.fire({
          title: 'Success',
          text: 'Card has been permanently deactivated',
          icon: 'success',
          confirmButtonText: 'OK'
        })
      } catch (error) {
        console.error('Error deactivating card:', error)
        // 顯示錯誤訊息
        Swal.fire({
          title: 'Error',
          text: error.message || 'Failed to deactivate card',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      }
    }
  } catch (error) {
    console.error('Error calling deactivate:', error)
  }
}

function handleKeydown(e) {
  if (showKycModal.value && e.key === 'Escape') {
    closeKycModal()
    return
  }

  if (showPopover.value && e.key === 'Escape') {
    cancelSwitch()
  }
}

// 監聽卡片狀態變化，自動更新開關狀態
watch(cardStatus, (newStatus) => {
  console.log('卡片狀態變化:', newStatus)
  
  // 根據新狀態更新開關
  if (newStatus === 'inactive') {
    lockCard.value = true
    deactivateCard.value = false
  } else if (newStatus === 'lost_or_stolen') {
    lockCard.value = false
    deactivateCard.value = true
  } else if (newStatus === 'active') {
    lockCard.value = false
    deactivateCard.value = false
  }
  
  console.log('開關狀態已更新:', {
    cardStatus: newStatus,
    lockCard: lockCard.value,
    deactivateCard: deactivateCard.value
  })
}, { immediate: true })

watch(
  shouldPromptKyc,
  (shouldShow) => {
    if (shouldShow && !hasShownKycModal.value) {
      showKycModal.value = true
      hasShownKycModal.value = true
      return
    }

    if (!shouldShow) {
      showKycModal.value = false
      hasShownKycModal.value = false
    }
  },
  { immediate: true }
)

// 監聽日期變化，重新查詢交易記錄
watch([dateFrom, dateTo], () => {
  if (activeTab.value === 'transactions') {
    currentPage.value = 1
    searchTransactions(1)
  }
})

// 監聽 tab 切換
watch(activeTab, (newTab) => {
  if (newTab === 'transactions') {
    // 切到交易分頁時，預設收起篩選區
    showFilters.value = false
    searchTransactions(1)
  }
})

onMounted(async () => {
  window.addEventListener('keydown', handleKeydown)
  
  // 載入卡片資訊
  try {
    await cardStore.fetchCardInfo()
    await cardStore.getKYCStatus()
    console.log('Card info loaded:', cardStore.cardInfo)
    
    // 根據卡片狀態設置開關初始狀態
    if (cardStore.cardInfo?.status === 'inactive') {
      lockCard.value = true  // inactive 狀態時，temporarily lock card 應該是開啟的
    } else if (cardStore.cardInfo?.status === 'lost_or_stolen') {
      deactivateCard.value = true  // lost_or_stolen 狀態時，lost/stolen 應該是開啟的
    }
    
    console.log('開關狀態設置完成:', {
      cardStatus: cardStore.cardInfo?.status,
      lockCard: lockCard.value,
      deactivateCard: deactivateCard.value
    })
    
    // 初始化時載入交易記錄
    if (activeTab.value === 'transactions') {
      searchTransactions(1)
    }
  } catch (error) {
    console.error('Failed to load card info:', error)
  }
})
onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown)
})
</script>

<style scoped>
.card {
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 100%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
  }
.card-title {
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  color: #051C2C;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
  align-items: center;
  display: flex;
  justify-content:space-between;
}
.card-title img{
  width: 32px;
  height: 32px;
  padding: 6px;
  background-color:#EEF1F4;
  border-radius: 6px;
}

/* 專用縮小搜尋圖標尺寸，避免被全域 img 規則影響 */
.search-icon {
  width: 32px !important;
  height: 32px !important;
  padding: 6px;
  object-fit: contain;
}

.small-card-img {
    max-width: 220px;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card-number {
    margin-top: 25px;
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
    color: #051C2C;
}

.left-text {
    margin-top: 20px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    color: #051C2C;
}

.card-balance-amount {
    margin-top: 10px;
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 42px;
    line-height: 53px;
    color: #051C2C;
}

.card-verification-status {
    margin-top: 10px;
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
}

.status-verified {
    color: #00c962;
}

.status-blocked {
    color: #FF4040;
}

.blocked-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    color: #e53935;
    font-size: 18px;
    border: 2px solid #e53935;
    margin-right: 10px;
}

.unverified-text {
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
    color: #051C2C;
}

.btn-verify {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 32px;
    gap: 10px;
    height: 46px;
    border: 2px solid #00C962;
    border-radius: 30px;
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 23px;
    color: #051C2C;
}

.btn-verify:hover {
    background: #00C962;
    color: #fff;
}

.external-link {
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: #5E707D;
}

.switch-row {
    display: flex;
    flex-direction: column;
    gap: 18px;
}
.custom-switch-group {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    min-height: 32px;
}
.custom-switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 44px;
    height: 24px;
    vertical-align: middle;
}
.custom-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}
.custom-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border: 2px solid #22313f;
    border-radius: 24px;
    transition: .2s;
}
.custom-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    background-color: #22313f;
    border-radius: 50%;
    transition: .2s;
}
.custom-slider.checked {
    border: 2px solid #e53935;
    background: #fff;
}
.custom-slider.checked:before {
    background-color: #e53935;
    left: 22px;
}
/* 禁用狀態的樣式 */
.custom-switch input:disabled ~ .custom-slider {
    cursor: not-allowed;
    background: #f5f5f5;
    border: 2px solid #d0d0d0;
    opacity: 0.6;
}
.custom-switch input:disabled ~ .custom-slider:before {
    background-color: #d0d0d0;
}
.custom-switch input:disabled ~ .custom-slider.checked {
    border: 2px solid #f5a9a9;
    background: #f5f5f5;
}
.custom-switch input:disabled ~ .custom-slider.checked:before {
    background-color: #f5a9a9;
}
.custom-switch-group:has(input:disabled) .switch-label {
    color: #999;
    opacity: 0.6;
}
.switch-label {
    font-family: 'Mulish';
    font-size: 16px;
    color: #22313f;
    vertical-align: middle;
    display: flex;
    align-items: center;
    height: 24px;
    margin-left: 6px;
}
.switch-popover-mask {
    position: absolute;
    left: 60px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2000;
    pointer-events: all;
}
.switch-popover {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.12);
  border: 2px solid #a398f7;
  padding: 24px 20px 20px 20px;
  min-width: 260px;
  max-width: 95vw;
  text-align: left;
  outline: none;
  pointer-events: all;
  word-break: break-word;
}
.popover-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #22313f;
    margin-bottom: 12px;
    font-family: 'Euclid Square', sans-serif;
}
.popover-desc {
    color: #22313f;
    font-size: 1rem;
    margin-bottom: 24px;
    font-family: 'Mulish', sans-serif;
}
.popover-actions {
    display: flex;
    justify-content: flex-end;
    gap: 32px;
}
.btn-link.text-secondary {
    color: #b0b7c3;
    font-weight: 500;
    font-size: 1rem;
    background: none;
    border: none;
    cursor: pointer;
}
.btn-link.text-primary {
    color: #a398f7;
    font-weight: 600;
    font-size: 1rem;
    background: none;
    border: none;
    cursor: pointer;
}

/* Transaction History Styles */
.transaction-history {
    padding: 10px;
}

.transaction-title {
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
    color: #051C2C;
}

.search-section {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-bottom: 24px;
}

.date-filters {
    display: flex;
    gap: 10px;
}

.filter-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 280px;
}

.filter-group label {
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #051C2C;
}

.search-btn {
    width: 325px;
    height: 46px;
    background: #00C962;
    border-radius: 30px; 
    border: none;
    margin-bottom: 3px;
    color: black;
}

.search-btn:hover {
    background: #00a34f;
    color: black;
}

.table-container {
    overflow-x: auto;
    margin-top: 20px;
}

.transaction-table {
    width: 100%;
    border-collapse: collapse;
    font-family: 'Mulish';
    border: none;
}

.transaction-table th {
    background: none;
    font-family: 'Mulish';
    font-weight: 600;
    font-size: 16px;
    color: #051C2C;
    padding: 15px 20px;
    text-align: left;
    /* border-bottom: 1px solid #E5E5E5; */
    border-top: none;
    border-left: none;
    border-right: none;
}

.transaction-table td {
    padding: 15px 20px;
    font-family: 'Mulish';
    font-size: 16px;
    color: #051C2C;
    /* border-bottom: 1px solid #F0F0F0; */
    border-top: none;
    border-left: none;
    border-right: none;
}

.transaction-table tr:hover {
    background: none;
}

.money-in {
    color: #00C962;
    font-weight: 600;
    width: 100%;
}

.money-out {
    color: #FF4040;
    font-weight: 600;
}

.mobile-card-detail {
  width: 100vw;
  min-height: 100vh;
  background: #fff;
  padding: 0 0 40px 0;
  box-sizing: border-box;
  overflow-y: auto;
}
.card-tabs {
  display: flex;
  /* border-bottom: 1.5px solid #e5e5e5; */
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
}
.tab {
  flex: 1;
  text-align: center;
  padding: 18px 0 14px 0;
  font-family: 'Euclid Square', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #5E707D;
  cursor: pointer;
  border-bottom: 2.5px solid transparent;
  transition: color 0.2s, border-bottom 0.2s;
}
.tab.active {
  color: #051C2C;
  border-bottom: 2.5px solid #685fdf;
  background: #fff;
}
.tab-content {
  padding: 0 12px;
  margin-bottom: 100px;
  box-sizing: border-box;
  width: 100%;
  overflow-x: hidden;
}
.transactions-list {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  margin-right: 0;
  box-sizing: border-box;
  width: 100%;
}
.transaction-item {
  background: #fff;
  /* border-bottom: 1px solid #e5e5e5; */
  padding: 16px 0 10px 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  box-sizing: border-box;
}
.transaction-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 4px;
}
.transaction-text {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: right;
  color: #051C2C;
  flex-shrink: 0;
  min-width: 0;
  width: 25%;
}
.amount-header {
  justify-content: flex-end;
  padding-right: 4px;
}
.balance-header {
  justify-content: flex-end;
  padding-right: 4px;
}
.transaction-date {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: #051C2C;
  width: 50%;
  flex-shrink: 0;
}
.transaction-balance {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: #051C2C;
  width: 25%;
  text-align: right;
  flex-shrink: 0;
  padding-right: 4px;

}
.transaction-desc {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #5E707D;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.transaction-amount {
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  margin-top: 2px;
  width: 25%;
  text-align: right;
  flex-shrink: 0;
  padding-right: 4px;
}
.transaction-amount.in {
  color: #00C962;
}
.transaction-amount.out {
  color: #FF4040;
}
@media (max-width: 600px) {
  .mobile-card-detail {
    padding: 0 0 40px 0;
  }
  .tab-content {
    padding: 0 6px;
  }
  .transactions-list {
    padding: 0;
  }
  .transaction-item {
    padding: 12px 0 8px 0;
  }
  .transaction-row {
    padding: 0 2px;
  }
}

@media (max-width: 400px) {
  .switch-popover {
    min-width: unset;
    max-width: 98vw;
    padding: 16px 6px 16px 6px;
    font-size: 15px;
  }
  .popover-title {
    font-size: 1rem;
  }
  .popover-desc {
    font-size: 0.95rem;
  }
}

.pagination-container {
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow-x: auto;
}
.pagination-controls { display:flex; align-items:center; justify-content: space-between; width:100%; }
.pagination-left, .pagination-right { display:flex; align-items:center; gap:8px; flex:1; }
.pagination-left { justify-content:flex-start; }
.pagination-right { justify-content:flex-end; }
.pagination-center { flex:0 0 auto; display:flex; align-items:center; gap:6px; }
.arrow-icon {
  width: 28px;
  height: 28px;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}
.page-info {
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
}
.page-input {
  width: 40px;
  height: 30px;
  text-align: center;
  font-size: 16px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 0 5px;
}
button {
  border: none;
  background: none;
  cursor: pointer;
}
button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* 交易記錄樣式 */
.transaction-item {
  margin-bottom: 8px;
}

.transaction-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #99A6B4;
  width: 100%;
  cursor: pointer;
}

.transaction-row:active {
  background: #f5f6f8;
}

.transaction-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0; /* 允許內容收縮而不擠爆版面 */
}

.transaction-date {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  line-height: 1.2;
}

.transaction-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.3;
  white-space: nowrap;       /* 單行顯示 */
  overflow: hidden;          /* 超出隱藏 */
  text-overflow: ellipsis;   /* 省略號 */
}

.transaction-right {
  display: flex;
  flex-direction: row; /* 橫向排列 amount 與 balance */
  align-items: center;
  justify-content: flex-end;
  gap: 16px; /* 調整 Amount 與 Balance 間距 */
  min-width: 0; /* 讓左側能取得更多空間 */
}

/* 標題列 */
.transaction-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0 8px 0;
  font-size: 15px;
}
.transaction-header .header-left { flex: 1; }
.transaction-header .header-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px; /* 與列表一致的間距 */
  min-width: 0;
}
.transaction-header .header-amount { width:70px; text-align: right;  }
.transaction-header .header-balance { width: 70px; text-align: right; }

@media (max-width: 400px) {
  .transaction-right { min-width: 150px; gap: 14px; }
  .transaction-header .header-right { min-width: 150px; gap: 14px; }
}

.transaction-amount {
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
  padding-left: 4px;
  flex: 0 0 70px; /* 固定寬度 */
}

.transaction-balance {
  font-size: 13px;
  font-weight: 500; /* 修正 */
  color: #333;
  text-align: right;
  white-space: nowrap;
  flex: 0 0 70px; /* 固定寬度 */
}

.money-in {
  color: #28a745;
}

.money-out {
  color: #dc3545;
}

.transaction-balance {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  text-align: right;
}

.no-transactions {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.no-transactions p {
  margin: 0;
  font-size: 16px;
}

/* 交易歷史樣式 */
.transaction-history {
  padding: 20px;
}

.transaction-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.transaction-note {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.search-section {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

/* 展開/收起動畫 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all .18s ease;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.date-filters {
  display: flex !important;
  flex-direction: row !important;
  gap: 15px;
  margin-bottom: 15px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
}

.filter-group label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.input-group {
  position: relative;
}

.input-group :deep(.dp__input_icons),
.input-group :deep(.dp_input_icons) {
  padding: 0 !important;
}

.input-group :deep(.dp__input_icon_pad),
.input-group :deep(.dp_input_icon_pad) {
  padding-left: 20px !important;
}



/* 分頁樣式 */
.pagination-container {
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow-x: auto;
  position: sticky;
  bottom: 0;
  z-index: 100;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.15);
  min-height: 60px;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
 width: 100%;
}

.pagination-btn {
  width: 32px;
  height: 32px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
  color: #495057;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.pagination-btn:hover:not(:disabled) {
  background-color: #e3f2fd;
  border-color: #2196f3;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f5f5f5;
  border-color: #e0e0e0;
  box-shadow: none;
}

.pagination-btn:disabled .arrow-icon {
  opacity: 0.4;
  filter: grayscale(100%);
}

.page-input-container {
  display: flex;
  align-items: center;
  gap: 1px;
  margin: 0 2px;
  flex-shrink: 0;
}

.page-label,
.page-total {
  font-size: 12px;
  color: #495057;
  white-space: nowrap;
  font-weight: 500;
}

.page-input {
  width: 40px;
  height: 28px;
  text-align: center;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 12px;
  background-color: white;
  color: #495057;
}

.pagination-info {
  text-align: center;
  font-size: 12px;
  color: #495057;
  flex-shrink: 0;
  white-space: nowrap;
  margin-top: 10px;
  font-weight: 500;
}
@media (max-width: 600px) {
  .pagination-container {
    padding: 10px;
    overflow-x: auto;
    margin-bottom: 50px;
  }
  
  .pagination-controls {
    gap: 1px;
    min-width: 200px;
  }
  
  .pagination-btn {
    width: 28px;
    height: 28px;
  }
  
  .page-input {
    width: 35px;
    height: 24px;
    font-size: 11px;
  }
  
  .page-label,
  .page-total {
    font-size: 15px;
  }
  
  .pagination-info {
    font-size: 11px;
  }
}

/* Deactivate / Cancel Card Button Styles */
.deactivate-cancel-container {
  position: relative;
  margin-top: 20px;
  padding: 0 12px;
}

.btn-deactivate-cancel {
  background: none;
  border: none;
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: black;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  width: 100%;
  text-align: left;
}

.btn-deactivate-cancel:hover {
  color: #333;
}

/* Change PIN 按鈕禁用樣式 */
.btn-verify:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #f5f5f5;
    border-color: #d0d0d0;
    color: #999;
}

.btn-verify:disabled:hover {
    background-color: #f5f5f5;
    color: #999;
}

/* Deactivate / cancel card 按鈕禁用樣式 */
.btn-deactivate-cancel:disabled,
.btn-deactivate-cancel.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    color: #999;
    pointer-events: none;
}

.btn-deactivate-cancel:disabled:hover,
.btn-deactivate-cancel.disabled:hover {
    color: #999;
    text-decoration: none;
}

.kyc-modal-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: rgba(5, 28, 44, 0.45);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  box-sizing: border-box;
  overflow-y: auto;
}

.kyc-modal {
  width: 100%;
  max-width: 360px;
  background: #fff;
  border-radius: 16px;
  padding: 22px 18px;
  text-align: center;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.22);
  margin: auto;
}

.kyc-modal-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: 'Euclid Square';
  font-size: 34px;
  line-height: 1.2;
  font-weight: 600;
  color: #051C2C;
  margin-bottom: 12px;
}

.kyc-alert-icon {
  width: 24px;
  height: 24px;
}

.kyc-modal-text {
  font-family: 'Mulish';
  font-size: 22px;
  line-height: 1.35;
  color: #051C2C;
}

.kyc-modal-link {
  display: inline-block;
  margin-top: 12px;
  font-family: 'Mulish';
  font-size: 22px;
  line-height: 1.35;
  color: #3f56ff;
  text-decoration: underline;
  word-break: break-all;
}

.kyc-modal-link-disabled {
  margin-top: 12px;
  font-family: 'Mulish';
  font-size: 16px;
  line-height: 1.35;
  color: #5E707D;
}

.kyc-modal-warning {
  margin-top: 12px;
  font-family: 'Mulish';
  font-size: 22px;
  line-height: 1.35;
  color: #ff4040;
}

</style>

<style>
/* Teleport 到 body 後，使用全域 class 控制手機版日期彈窗位置與尺寸 */
.mobile-datepicker-menu {
  z-index: 100000 !important;
  width: min(300px, calc(100vw - 24px)) !important;
  min-width: 0 !important;
  max-width: calc(100vw - 24px) !important;
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%) !important;
  box-sizing: border-box;
}

.mobile-datepicker-menu .dp__calendar_header_item,
.mobile-datepicker-menu .dp__month_year_select,
.mobile-datepicker-menu .dp__inner_nav {
  font-size: 14px !important;
}

.mobile-datepicker-menu .dp__cell_inner {
  width: 32px !important;
  height: 32px !important;
  font-size: 14px !important;
}

.mobile-datepicker-menu .dp__action_row {
  padding: 8px 10px !important;
}

</style>